/**
 * Google Analytics (GA4). The tag's setup is written into index.html's <head>
 * by the build (googleTag in vite.config.ts), which also loads Google's
 * library a little after the page; the dev server leaves it all out, so local
 * play never reports. This module only sends the game's own events, through
 * the gtag that snippet defines; they queue until the library arrives.
 * Measurement ids are public by design (they ship in every page), so it lives
 * here rather than in a secret.
 */

/** The GA4 measurement id ("G-XXXXXXXXXX"); empty disables analytics. */
export const GA_MEASUREMENT_ID = 'G-V5BW228MT6';

type Gtag = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: Gtag;
  }
}

let enabled = false;

/** Turns event reporting on when the page carries the tag (production only). */
export function initAnalytics(): void {
  enabled = import.meta.env.PROD && typeof window.gtag === 'function';
}

/** Report a custom event; a no-op when analytics is off. */
export function track(event: string, params?: Record<string, string | number | boolean>): void {
  if (!enabled) return;
  window.gtag?.('event', event, params);
}
